module.exports = __webpack_public_path__ + "img/gold_icon.f5fa3226.png";